/**
 * @jsxRuntime classic
 * @jsx jsx
 */


import { defineMessages } from 'react-intl';

export const messages: {
	scrollLeft: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	scrollRight: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	scrollLeft: {
		id: 'search_ai.knowledge_carousel.scroll_left',
		defaultMessage: 'Scroll left',
		description: 'Label for the scroll left button',
	},
	scrollRight: {
		id: 'search_ai.knowledge_carousel.scroll_right',
		defaultMessage: 'Scroll right',
		description: 'Label for the scroll right button',
	},
});
